import { type DocumentNode, gql } from '@apollo/client';

export const getReactionsQuery: DocumentNode = gql`
	query mainReactionsSummaryQuery(
		$cloudId: ID!
		$contentId: ID!
		$contentType: String!
		$containerId: ID!
		$containerType: String
	) {
		reactionsSummary(
			cloudId: $cloudId
			contentId: $contentId
			contentType: $contentType
			containerId: $containerId
			containerType: $containerType
		) {
			ari
			containerAri
			reactionsSummaryForEmoji {
				emojiId
				count
				reacted
			}
		}
	}
`;
